import * as yup from 'yup';

import localizedStrings from 'localization';

export const submissionFeedbackSchema = yup.object().shape({
  rating: yup.number().min(1).max(5).required(),
  feedback: yup.string().required(localizedStrings.feedbackMessageValidation),
});
